import { ShowRecordingDashboardRequestSchema, ShowRecordingDashboardResponseSchema } from './show-recording-dashboard.schema';
export const showRecordingDashboardContract = {
    method: 'GET',
    path: '/api/v2/recording-dashboard',
    description: 'Retrieve recording progress dashboard for org managers and process owners',
    requestSchema: ShowRecordingDashboardRequestSchema,
    responseSchema: ShowRecordingDashboardResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user lacks RecordingDashboard read permission'
        }
    }
};

//# sourceMappingURL=show-recording-dashboard.contract.js.map